<template>

    <div
      class="el-select"
      :class="[selectSize ? 'el-select--' + selectSize : '']"
      @click.stop="toggleMenu"
      v-clickoutside="handleClose">

      <el-input
        ref="reference"
        v-model="selectedLabel"
        type="text"
        :placeholder="currentPlaceholder"
        :name="name"
        :id="id"
        :autocomplete="autocomplete"
        :size="selectSize"
        :disabled="selectDisabled"
        :readonly="readonly"
        :validate-event="false"
        :class="{ 'is-focus': visible }"
        @focus="handleFocus"
        @blur="handleBlur"
        @keyup.native="debouncedOnInputChange"
        @keydown.native.down.stop.prevent="navigateOptions('next')"
        @keydown.native.up.stop.prevent="navigateOptions('prev')"
        @keydown.native.enter.prevent="selectOption"
        @keydown.native.esc.stop.prevent="visible = false"
        @keydown.native.tab="visible = false"
        @paste.native="debouncedOnInputChange"
        @mouseenter.native="inputHovering = true"
        @mouseleave.native="inputHovering = false">
        <template slot="prefix" v-if="$slots.prefix">
          <slot name="prefix"></slot>
        </template>
        <template slot="suffix">
          <i v-show="!showClose" :class="['el-select__caret', 'el-input__icon', 'el-icon-' + iconClass]"></i>
          <i v-if="showClose" class="el-select__caret el-input__icon el-icon-circle-close" @click="handleClearClick"></i>
        </template>
      </el-input>

      <transition
        name="el-zoom-in-top"
        @before-enter="handleMenuEnter"
        @after-leave="doDestroy">
        <el-select-menu
          ref="popper"
          :append-to-body="popperAppendToBody"
          v-show="visible && emptyText !== false">
          <el-scrollbar
            tag="div"
            wrap-class="el-select-dropdown__wrap"
            view-class="el-select-dropdown__list"
            ref="scrollbar"
            v-show="treeData.length > 0 && !loading">
            
              <el-tree ref="form-tree" 
                class="dict-tree"
                :data="treeData" 
                :props="defaultProps" 
                @node-click="handleNodeClick" 
                :disabled="disabled" 
                :currentNodeKey="currentNodeKey" 
                :defaultExpandedKeys="treeExpandedKeys"
                :node-key="nodeKey" ></el-tree>

          </el-scrollbar>
          <template v-if="emptyText && (!allowCreate || loading || (allowCreate && treeData.length === 0 ))">
            <slot name="empty" v-if="$slots.empty"></slot>
            <p class="el-select-dropdown__empty" v-else>
              {{ emptyText }}
            </p>
          </template>
        </el-select-menu>
      </transition>
    


    </div>




</template>

<script  type="text/babel" >

// 父子组件时间推送
import Emitter from 'element-ui/src/mixins/emitter';
// 处理聚焦
import Focus from 'element-ui/src/mixins/focus';
// 处理多语
import Locale from 'element-ui/src/mixins/locale';
// 输入框
import ElInput from 'element-ui/packages/input';
// 处理下拉内容
import ElSelectMenu from 'element-ui/packages/select/src/select-dropdown.vue';
import NavigationMixin from 'element-ui/packages/select/src/navigation-mixin';
// 处理滚动
import ElScrollbar from 'element-ui/lib/scrollbar';
// 动画
import debounce from 'throttle-debounce/debounce';
// 处理点击框外
import Clickoutside from 'element-ui/src/utils/clickoutside';

  


import { addResizeListener, removeResizeListener } from 'element-ui/src/utils/resize-event';
import scrollIntoView from 'element-ui/src/utils/scroll-into-view';
import { isIE, isEdge, valueEquals } from "element-ui/src/utils/util";
// import { isKorean } from 'element-ui/src/utils/shared';


export default {
  mixins: [Emitter, Locale, Focus('reference'), NavigationMixin],
  
  name: "selectTree",
  
  componentName: 'selectTree',

  components: {
      ElInput,
      ElSelectMenu,
      ElScrollbar
  },

  directives: { Clickoutside },

  inject: {
    elForm: {
      default: ''
    },

    elFormItem: {
      default: ''
    }
  },

  provide() {
    return {
      'SelectTree': this
    };
  },
  
  props: {
    name: String,
    id: String,
    value: {
      required: true
    },
    autocomplete: {
      type: String,
      default: 'off'
    },
    automaticDropdown: Boolean,
    size: String,
    disabled: {
      type: Boolean,
      default: false,
    },
    clearable: Boolean,
    allowCreate: {
      type: Boolean,
      default: true
    },
    loading: Boolean,
    popperClass: String,
    remote: Boolean,
    loadingText: String,
    noMatchText: String,
    noDataText: String,
    placeholder: {
      type: String,
      required: false
    },
    popperAppendToBody: {
      type: Boolean,
      default: true
    },
    multiple: {
      type: Boolean,
      default: false
    },

    // 树字典数据
    treeData: {
        type: Array,
        default: function(){
            return [];
        }
    },
    // 主键
    nodeKey: {
        type: String,
        default: function() {
            return 'oid';
        }
    },
    // 输的默认属性
    defaultProps: {
        type: Object,
        default: function() {
            return {
                children: 'children',
                label: 'name',
            };
        }
    }
  },
  computed: {
    currentNodeKey() {
      if(this.value == '' || this.isNull(this.value) || this.isUndefined(this.value)) {
        return undefined;
      }
      return this.value;
    },
    treeExpandedKeys(){
      if(this.value) {
        let keys = [];
        keys.push(this.value);
        return keys;
      }
      return [];
    },
    _elFormItemSize() {
      return (this.elFormItem || {}).elFormItemSize;
    },

    readonly() {
      return !this.filterable || this.multiple || (!isIE() && !isEdge() && !this.visible);
    },
    isObject() {
      return (
        Object.prototype.toString.call(this.value).toLowerCase() ===
        "[object object]"
      );
    },

    showClose() {
      let hasValue = this.multiple
        ? Array.isArray(this.value) && this.value.length > 0
        : this.value !== undefined && this.value !== null && this.value !== '';
      let criteria = this.clearable &&
        !this.selectDisabled &&
        this.inputHovering &&
        hasValue;
      return criteria;
    },

    iconClass() {
      return this.remote && this.filterable ? '' : (this.visible ? 'arrow-up is-reverse' : 'arrow-up');
    },

    debounce() {
      return this.remote ? 300 : 0;
    },

    emptyText() {
      if (this.loading) {
        return this.loadingText || this.t('el.select.loading');
      } else {

        if(this.value == '') {
          return this.noDataText || this.t('el.select.noData');
        }
      }
      return null;
    },
    selectSize() {
      return this.size || this._elFormItemSize || (this.$ELEMENT || {}).size;
    },
    selectDisabled() {
      return this.disabled || (this.elForm || {}).disabled;
    },
    propPlaceholder() {
      return typeof this.placeholder !== 'undefined' ? this.placeholder : this.t('el.select.placeholder');
    }

  },
  data() {
    return {
      // 显示选中内容
      selectedLabel: '',
      currentPlaceholder: '',
      // 显示value
      label: '',
      index: -1,
      groupDisabled: false,
      visible: false,
      hitState: false,
      hover: false,

      inputWidth: 0,
      initialInputHeight: 0,
      cachedPlaceHolder: '',

      inputHovering: false,
      softFocus: false,
    };
  },
  mounted: function() {

    
    // 增加resize监听
    addResizeListener(this.$el, this.handleResize);

    const reference = this.$refs.reference;
    if (reference && reference.$el) {
      const sizeMap = {
        medium: 36,
        small: 32,
        mini: 28
      };
      const input = reference.$el.querySelector('input');
      // 计算input的高
      this.initialInputHeight = input.getBoundingClientRect().height || sizeMap[this.selectSize];
    }
    this.$nextTick(() => {
      if (reference && reference.$el) {
        this.inputWidth = reference.$el.getBoundingClientRect().width;
      }
    });

    // 推送选中事件
    // this.setSelected();
    this.$emit('setSelected');


  },
  watch: {

    selectDisabled() {
      this.$nextTick(() => {
        // 没有多选暂时不需要
        // this.resetInputHeight();
      });
    },

    propPlaceholder(val) {
      this.cachedPlaceHolder = this.currentPlaceholder = val;
    },

    visible(val) {

      if (!val) {
        this.broadcast('ElSelectDropdown', 'destroyPopper');
        // 取消聚焦
        if (this.$refs.input) {
          this.$refs.input.blur();
        }
        this.$nextTick(() => {
          if (this.$refs.input &&
            this.$refs.input.value === '' ) {
            this.currentPlaceholder = this.cachedPlaceHolder;
          }
        });

      } else {
        this.broadcast('ElSelectDropdown', 'updatePopper');
      }

      // 推送全局显示改变
      this.$emit('visible-change', val);

    },

    value(val, oldVal) {

      this.setSelected();

      // 通知父组件值改变
      if (!valueEquals(val, oldVal)) {
        this.dispatch('ElFormItem', 'el.form.change', val);
      }

    },
  },

  methods: {
    isNull(value) {
      return Object.prototype.toString.call(value).toLowerCase() === '[object null]';
    },
    isUndefined(value) {
      return Object.prototype.toString.call(value).toLowerCase() === '[object undefined]';
    },
    resetInputWidth() {
      this.inputWidth = this.$refs.reference.$el.getBoundingClientRect().width;
    },
    handleResize() {
      this.resetInputWidth();
    },
    scrollToSelected() {
      // 滚动到选中的位置
      const target = this.$refs['form-tree'].$el.querySelector('.el-tree-node.is-current');
      if (this.$refs.popper && target) {
        const menu = this.$refs.popper.$el.querySelector('.el-select-dropdown__wrap');
        scrollIntoView(menu, target);
      }
      this.$refs.scrollbar && this.$refs.scrollbar.handleScroll();

    },
    handleMenuEnter() {
      this.$nextTick(() => {
        
        // 滚动到选中的地方
        this.scrollToSelected()

      });
    },
    doDestroy() {
      this.$refs.popper && this.$refs.popper.doDestroy();
    },

    toggleMenu() {
      if (!this.selectDisabled) {
        if (this.menuVisibleOnFocus) {
          this.menuVisibleOnFocus = false;
        } else {
          this.visible = !this.visible;
        }
        if (this.visible) {
          (this.$refs.input || this.$refs.reference).focus();
        }
      }
    },

     handleFocus(event) {
        if (!this.softFocus) {
          if (this.automaticDropdown || this.filterable) {
            this.visible = true;
            if (this.filterable) {
              this.menuVisibleOnFocus = true;
            }
          }
          this.$emit('focus', event);
        } else {
          this.softFocus = false;
        }
      },

      blur() {
        this.visible = false;
        this.$refs.reference.blur();
      },

      emitChange(val) {
        if (!valueEquals(this.value, val)) {
          this.$emit('change', val);
        }
      },

      handleBlur(event) {
        setTimeout(() => {
          if (this.isSilentBlur) {
            this.isSilentBlur = false;
          } else {
            this.$emit('blur', event);
          }
        }, 50);
        this.softFocus = false;
      },
      deleteSelected(event) {
        event.stopPropagation();
        const value = this.multiple ? [] : '';
        this.$emit('input', value);
        this.emitChange(value);
        this.$refs['form-tree'].setCurrentKey(null);
        this.visible = false;
        this.$emit('clear');
        
      },
      handleClearClick(event) {
        this.deleteSelected(event);
      },

    handleClose() {
      this.visible = false;
    },

    setSelected(){

      let treeItem = this.treeFindItem(this.treeData, this.value);
      let text = treeItem != '' ? treeItem[this.defaultProps.label] : '';

      this.selectedLabel = text;
      this.$nextTick(() => {
        this.selectedLabel = text;
      }); 
      

    },
    treeFindItem(data, value) {

        for(let i=0; i<data.length; i++) {
            if(data[i][this.nodeKey] == value) {
                return data[i];
            } else {
                // 获取子数据
                if(!data[i][this.defaultProps.children] 
                    || data[i][this.defaultProps.children].length==0) {
                    continue;  
                }
                let res = this.treeFindItem(data[i][this.defaultProps.children], value);
                if(res == '') {
                    continue;
                }
                return res;
            }
        }

        return '';

    },
    handleNodeClick(data) {

      let value = data[this.nodeKey];
      // 设置值
      this.$emit('input', value);
      // 通知选中
      this.$emit('setSelected');

      if (this.value != value) {
          this.$emit('change', value);
      }

      this.visible = false;

    }
  },

  created() {
    this.cachedPlaceHolder = this.currentPlaceholder = this.propPlaceholder;

    this.debouncedOnInputChange = debounce(this.debounce, () => {
      this.onInputChange();
    });

    this.debouncedQueryChange = debounce(this.debounce, (e) => {
      this.handleQueryChange(e.target.value);
    });

    // // 监听选中事件
    this.$on('setSelected', this.setSelected);
    
  },

  beforeDestroy() {

    if (this.$el && this.handleResize) removeResizeListener(this.$el, this.handleResize);

    this.$off('setSelected');

  },
};
</script>

